import { Stack, Typography } from "@mui/material";
import type { FC } from "react";

type Props = {
	role: string;
	names: string;
};

export const ActivityParticipantGroup: FC<Props> = ({ role, names }) => (
	<Stack>
		<Typography variant="button" color="text.secondary" mb={0.4}>
			{role}
		</Typography>
		<Typography variant="body1">{names}</Typography>
	</Stack>
);
